import { useCallback } from 'react'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { MigrationConsentData } from 'common/billing/entities/migrationConsent/interfaces'
import { getMigrationConsentState } from 'common/billing/entities/migrationConsent/selectors'
import { migrationConsentActions } from 'common/billing/redux/migrationConsent'

export const useMigrationConsent = () => {
  const dispatch = useAppDispatch()
  const { data: consentData } = useAppSelector(getMigrationConsentState)

  const mutate = useCallback(
    (payload: MigrationConsentData) => {
      dispatch(migrationConsentActions.setConsent(payload))
    },
    [dispatch],
  )

  return [consentData, mutate] as const
}
